














































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import ScorecardSubpage from '@/pages/scorecard/components/ScorecardSubpage.vue'
import {Action, Getter} from 'vuex-class'
import {ScorecardEntity} from '@/entities/scorecard'
import {sleep} from '@/utils/async'
import { embedded, postMessageToRNWebView } from '@/utils/react-native-webview'


@Component<ScorecardRoomToImproveList>({
    components: {ScorecardSubpage, Loading}
})
export default class ScorecardRoomToImproveList extends Vue {
    @Prop({type: String, default: null})
    public teamMemberUserId !: string

    @Getter public slide !: string
    @Getter public scorecard!: ScorecardEntity
    @Getter public scorecardOutdated!: boolean
    @Getter public scorecardLoading!: boolean

    @Action public loadScorecard
    @Action public setSlide

    public slideName = 'left'

    public beforeMount() {
        this.slideName = this.slide
    }

    public async mounted() {
        if (this.scorecardOutdated) {
            await this.loadScorecard(this.teamMemberUserId ?? null)
        }
    }

    // listen to willFocus event from webview if any
    public created() {
        window.addEventListener('willFocus', this.onReloadData)
    }

    public destroyed() {
        window.removeEventListener('willFocus', this.onReloadData)
    }

    public async onReloadData() {
        await this.loadScorecard(this.teamMemberUserId ?? null)
    }

    public get loading() {
        return this.scorecardLoading
    }

    public get sortedBadges() {
        return Object.entries(this.scorecard.badges.negative)
            .sort(([badge1, info1], [badge2, info2]) => info2.count - info1.count)
    }

    public get embedded() {
        return embedded
    }

    public async goRoomToImproveDetail(entry) {
        this.setSlide('left')
        this.slideName = 'right'
        await sleep(10)

        if (embedded) {
            postMessageToRNWebView({
                routeName: 'RoomToImproveDetail',
                params: {
                    badge: entry[0],
                    label: entry[1].label
                }
            })
        } else {
            if (this.teamMemberUserId) {
                await this.$router.push({ name: 'scorecardRoomToImproveDetailUser', params: { value: entry[0], teamMemberUserId: this.teamMemberUserId } })
            } else {
                await this.$router.push({ name: 'scorecardRoomToImproveDetail', params: { value: entry[0] } })
            }
        }
    }
}
